import { SupportTaskProcessor, SupportTaskStatus } from '@duke-hq/svc-api-db/client';

export function isTaskAssignable(task: {
  processor: SupportTaskProcessor;
  status: SupportTaskStatus;
}): boolean {
  return (
    task.processor === SupportTaskProcessor.HUMAN && task.status !== SupportTaskStatus.COMPLETED
  );
}
